// extracted by mini-css-extract-plugin
export default {"container":"LogoutPopUp_container__bsMKa","show":"LogoutPopUp_show__jzvpW","body":"LogoutPopUp_body__BpRoq"};